module.exports = __webpack_public_path__ + "static/media/Musics-3.c2bfe0d5.jpg";